import { button } from "../components/Button/Button.theme";

export const theme = {
  button,
};
